// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3URy1","title":"Images90_title__3elq1","images":"Images90_images__13ibK"};